export default __webpack_public_path__ + "static/hero-background-498e0e1031d6a9afbdc3df6c246f0a97.png";